export const FRIEND_GROUP_ID = '0';
export const NEW_GROUP_ID = 'new';
